import React from "react";
import text from "../config/text.json"
interface CommonType {
  [key: string]: string;
}
const commonData: CommonType = text;

export const getText = (key: string): string => {
  return commonData[key];
};
